import React, { useContext } from "react";
import { Context } from "../../../../utils/context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

const InstrumentSocket = ({
  item,
  latestClose = 0,
  latestBaseCloses = 0,
  onSelect,
  isActive = false, // New prop
}) => {
  const { IMG_URL } = useContext(Context);

  const current = Number(latestClose) || 0;
  const previous = Number(latestBaseCloses) || 0;
  const change = current - previous;
  const isUp = change > 0;
  const isDown = change < 0;
  // console.log("Image URL:",IMG_URL);
  // console.log("item logo:",item.logo)
  const companyId = item.Company?.id || item.id;
  const name = item.Company?.name || item.name;

  return (
    <div
      onClick={() => onSelect(companyId, name)}
      className={`bg-gray-800/60 rounded-xl p-4 cursor-pointer transition-all duration-300 border-2 flex items-center justify-between
        ${isActive 
          ? "border-blue-500 bg-blue-900/20 shadow-lg shadow-blue-500/20 scale-105" 
          : "border-gray-700 hover:border-gray-600 hover:bg-gray-800/80 hover:shadow-md"}
      `}
    >
      {/* Left: Logo + Name */}
      <div className="flex items-center space-x-4">
        {/* <img
          src={IMG_URL + item.logo}
          alt={name}
          className="w-10 h-10 rounded-lg object-cover"
          onError={(e) => (e.target.src = "/assets/images/default-logo.png")}
        /> */}
        <div>
          <p className={`font-medium ${isActive ? "text-blue-300" : "text-white"}`}>
            {name}
          </p>
          <p className="text-gray-500 text-xs">Crypto</p>
        </div>
      </div>

      {/* Right: Price + Change */}
      <div className="text-right">
        <p className={`text-lg font-bold ${isActive ? "text-blue-300" : "text-white"}`}>
          ${current.toFixed(2)}
        </p>
        <div className={`flex items-center justify-end space-x-1 text-sm ${isUp ? "text-green-400" : isDown ? "text-red-400" : "text-gray-500"}`}>
          <FontAwesomeIcon icon={isUp ? faArrowUp : faArrowDown} className="text-xs" />
          <span>{Math.abs(change).toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default InstrumentSocket;